module.exports = __webpack_public_path__ + "img/icon1.f0b5b082.png";